import request from '@/utils/request'


// 查询参与询价活动的商品列表
export function listActivityXunjiaGoods(query) {
  return request({
    url: '/activityXunjiaGoods/activityXunjiaGoods/list',
    method: 'get',
    params: query
  })
}

// 查询参与询价活动的商品分页
export function pageActivityXunjiaGoods(query) {
  return request({
    url: '/activityXunjiaGoods/activityXunjiaGoods/page',
    method: 'get',
    params: query
  })
}

// 查询参与询价活动的商品详细
export function getActivityXunjiaGoods(data) {
  return request({
    url: '/activityXunjiaGoods/activityXunjiaGoods/detail',
    method: 'get',
    params: data
  })
}

// 新增参与询价活动的商品
export function addActivityXunjiaGoods(data) {
  return request({
    url: '/activityXunjiaGoods/activityXunjiaGoods/add',
    method: 'post',
    data: data
  })
}

// 修改参与询价活动的商品
export function updateActivityXunjiaGoods(data) {
  return request({
    url: '/activityXunjiaGoods/activityXunjiaGoods/edit',
    method: 'post',
    data: data
  })
}

// 删除参与询价活动的商品
export function delActivityXunjiaGoods(data) {
  return request({
    url: '/activityXunjiaGoods/activityXunjiaGoods/delete',
    method: 'post',
    data: data
  })
}
